import React from 'react';
import { CheckCircle2, XCircle, Zap } from 'lucide-react';
import { useLang } from '../contexts/LanguageContext';
export function MechanismSection() {
  const {
    t
  } = useLang();
  return <section className="py-24 bg-dark-100 relative overflow-hidden" data-id="element-186" data-mp="cdddp1rc45ps">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-px bg-gradient-to-r from-transparent via-gold/50 to-transparent" data-id="element-187" data-mp="cfpx7jcqqo4y"></div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-188" data-mp="152kcm1upaxbk">
        <div className="text-center mb-16" data-id="element-189" data-mp="15457xtouakah">
          <div className="inline-flex items-center justify-center px-4 py-1.5 rounded-full bg-gold/10 border border-gold/20 mb-6" data-id="element-190" data-mp="104935s8biotv">
            <Zap className="w-4 h-4 text-gold mr-2" data-id="element-191" data-mp="vaoguxg37jai" />
            <span className="text-gold text-sm font-bold tracking-wide uppercase" data-id="element-192" data-mp="rbpcpf26jqk4">
              {t.mechanism.badge}
            </span>
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-193" data-mp="1nuwopgb5pcyw">
            {t.mechanism.title}
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto" data-id="element-194" data-mp="7pz2ra857b09">
            {t.mechanism.subtitle}
          </p>
        </div>

        <div className="bg-dark rounded-3xl border border-white/10 overflow-hidden shadow-2xl" data-id="element-195" data-mp="cpbrk0ikqs5h">
          <div className="grid grid-cols-3 bg-dark-200 border-b border-white/10 p-6" data-id="element-196" data-mp="3u6bqwv311qiy">
            <div className="col-span-1 font-bold text-gray-400 uppercase text-sm tracking-wider" data-id="element-197" data-mp="2yqtqfaq5rnm">
              {t.mechanism.colFeature}
            </div>
            <div className="col-span-1 font-bold text-gray-500 uppercase text-sm tracking-wider text-center" data-id="element-198" data-mp="3l3kbylay0cmk">
              {t.mechanism.colOther}
            </div>
            <div className="col-span-1 font-bold text-gold uppercase text-sm tracking-wider text-center" data-id="element-199" data-mp="3b7r3pe49b5al">
              {t.mechanism.colUs}
            </div>
          </div>

          <div className="divide-y divide-white/5" data-id="element-200" data-mp="19fkrnmzf45vv">
            {t.mechanism.comparisons.map((item, index) => <div key={index} className="grid grid-cols-3 p-6 items-center hover:bg-white/[0.02] transition-colors" data-id="element-201" data-mp="1eenwp7feec3u" data-mpi={index}>
                <div className="col-span-1 text-sm md:text-base font-medium text-gray-300 pr-4" data-id="element-202" data-mp="17y5jwcn8ho3t">
                  {item.feature}
                </div>
                <div className="col-span-1 flex flex-col items-center text-center px-2" data-id="element-203" data-mp="12zub858odjn6">
                  <XCircle className="w-5 h-5 text-red-500/50 mb-2" data-id="element-204" data-mp="yyiruhge9unf" />
                  <span className="text-sm text-gray-500" data-id="element-205" data-mp="1vngns2zvrym6">{item.other}</span>
                </div>
                <div className="col-span-1 flex flex-col items-center text-center px-2" data-id="element-206" data-mp="1qox283p78ouc">
                  <CheckCircle2 className="w-6 h-6 text-gold mb-2" data-id="element-207" data-mp="1lxx44v4cg0q9" />
                  <span className="text-sm font-bold text-white" data-id="element-208" data-mp="1lw3ynj5gvmju">
                    {item.us}
                  </span>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}